import { TasksProvider } from '../../../../providers/tasks/tasks';
import { TaskDetailPage } from '../../../task-detail/task-detail';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TaskQL } from '../../../../providers/tasks/models';
import { Provider } from '../../../../providers/providers/models';

@Component({
  selector: 'page-tasks-list',
  templateUrl: 'page-tasks-list.html'
})
export class TasksPageList {
  @Input('providers') providers: Provider[] = [];
  @Input('taskList') taskList: TaskQL[] = [];
  @Input('title') title: String = "";
  @Output() navigateEvent = new EventEmitter<string>();
  public taskListCollapsed: boolean = false;

  constructor(
    public navCtrl: NavController,
    private tasksProvider: TasksProvider,
  ) {}

  isVisible() {
    return this.taskList && this.taskList.length > 0 ? true : false;
  }
  
  expandCollapse() {
    this.taskListCollapsed = !this.taskListCollapsed;
  }

  openTask(task) {
    const cacheTask = JSON.parse(JSON.stringify(task));
    this.tasksProvider.setSelectedTask(cacheTask);
    this._fireNavigateEvent(cacheTask);
    this.navCtrl.push(TaskDetailPage, { task: cacheTask, fromSchedulePage: true });
  }
  
  _fireNavigateEvent(task) {
    this.navigateEvent.emit(task.snn);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/components/tasks/page-tasks-list.ts